import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { Dialog } from '@capacitor/dialog'

import { Button } from '@/components/atoms/Button'

import { usePromptToInstall } from '@/lib/promptToInstallProvider'

export const PWAInstallerPrompt: FC = () => {
  const { t } = useTranslation('common')

  const { pwaBeforeInstallPromptEvent } = usePromptToInstall()
  const handleOnInstall = () => {
    if (pwaBeforeInstallPromptEvent?.prompt) {
      pwaBeforeInstallPromptEvent.prompt()
    } else {
      Dialog.alert({
        message: t('PWAOnboarding.installedTip'),
      })
    }
  }

  return (
    <Button
      className="mt-9  mb-36 flex mx-auto"
      size="large"
      onClick={handleOnInstall}
      isDisabled={false}
    >
      {t('PWAOnboarding.installApp')}
    </Button>
  )
}
